/**
 * Combines all slice reducers and provides a rootReducer that supports a global RESET_STORE action.
 *
 * If an action with type 'RESET_STORE' is dispatched, the rootReducer will reset all slices to their initial state.
 * This is useful for scenarios like logout, where you want to clear all Redux state.
 */
import { combineReducers } from '@reduxjs/toolkit';

import accountSlice from './accountSlice';
import authSlice from './authSlice';
import foundCardSlice from './foundCardSlice';
import nomenclatureSlice from './nomenclatureSlice';
import userSlice from './userSlice';
import walletsSlice from './walletsSlice';

const appReducer = combineReducers({
	auth: authSlice,
	user: userSlice,
	wallets: walletsSlice,
	account: accountSlice,
	nomenclature: nomenclatureSlice,
	foundCard: foundCardSlice,
});

/**
 * Root reducer for the Redux store.
 *
 * If the RESET_STORE action is dispatched, all slices are reset to their initial state.
 * Otherwise, delegates to the combined reducers.
 *
 * @param state - The current Redux state
 * @param action - The dispatched Redux action
 * @returns The new Redux state
 */
const rootReducer = (state: any, action: any) => {
	if (action.type === 'RESET_STORE') {
		return appReducer(undefined, action);
	}
	return appReducer(state, action);
};

export default rootReducer;
